import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GDPR_SIGN_OPT_IN_COPY = createFcmDetails('gdpr_sign_opt_in_copy', {
	owner: 'supporters pack',
	context: 'petition page',
	description: `The copy to be used for the GDPR opt-in radio fields.
			If not specified, a default copy is used.
			Copy is selected based on the user's locale and the locales array in the JSON.
			Related FCM: gdpr_sign_opt_in
		`,
	template: {
		experiments: {
			gb_copy: {
				locales: ['en-GB'],
				variants: {
					control: {
						prompt: '',
						opt_in: '',
						opt_out: '',
						form_error: '',
						opt_out_warning: '',
					},
				},
			},
			es_copy: {
				locales: ['es-ES'],
				variants: {
					control: {
						prompt: '',
						opt_in: '',
						opt_out: '',
						form_error: '',
						opt_out_warning: '',
					},
				},
			},
		},
	},
	import: false,
});
